import React, { useEffect, useState } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CRow,
    CCol,
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CBadge,
    CButton,
    CFormInput,
    CInputGroup,
} from '@coreui/react-pro';
import { useStore } from '../../contexts/StoreContext';
import { ReferralDataItem } from '../../types/referral';
import * as DomicilappService from "../../services/DomicilappService";


export const MarketingReferrals: React.FC = () => {
    const { storeId, setStoreId, storeDetails } = useStore();

    const referralCode = storeDetails.referral_code;
    const referralLink = `https://api.domicilapp.com/user/referrer/${referralCode}`;
    const [copied, setCopied] = useState(false);
    const [referrals, setReferrals] = useState<ReferralDataItem[]>([]);
    const [referralsBalance, setReferralsBalance] = useState<number>(0);
    const [referralsActive, setReferralsActive] = useState<number>(0);
    const [referralsPending, setReferralsPending] = useState<number>(0);

    useEffect(() => {
        console.log("Entra aqui 25");
        if (storeId) {
            console.log("Entra aqui 27");
            setReferrals([]);
            setReferralsBalance(0);
            setReferralsActive(0);
            setReferralsPending(0);

            DomicilappService.getReferralDetailsByStore(storeId).then((response) => {
                if (response.status === 200) {
                    setReferrals(response.data.items);
                    setReferralsBalance(response.data.items.reduce((sum, ref) => sum + (ref.reward_amount || 0), 0));
                    setReferralsActive(response.data.items.filter((ref)=>ref.status==='paid').length);
                    setReferralsPending(response.data.items.filter((ref) => ref.status==='pending').length);
                }
            });
        }
    }, [storeId])

    const handleCopy = () => {
        navigator.clipboard.writeText(referralLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const currencyFormat = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 2
    });


    return (
        <>
            {/* METRICAS PRINCIPALES (Estructura sobria y limpia) */}
            <CRow className="mb-4 g-3">
                <CCol md={6}>
                    <CCard className="border border-secondary-subtle shadow-none bg-body rounded-3 h-100">
                        <CCardBody className="p-3">
                            <span className="text-body-secondary small text-uppercase fw-semibold">Ganancias Totales Acreditadas</span>
                            <h3 className="fw-bold my-1 text-body">{currencyFormat.format(referralsBalance)}</h3>
                            <small className="text-body-secondary">Acreditado directamente a la cartera de la tienda</small>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol md={6}>
                    <CCard className="border border-secondary-subtle shadow-none bg-body rounded-3 h-100">
                        <CCardBody className="p-3">
                            <span className="text-body-secondary small text-uppercase fw-semibold">Tiendas Registradas</span>
                            <h3 className="fw-bold my-1 text-body">{referralsActive+referralsPending} Comercio(s)</h3>
                            <small className="text-body-secondary">{referralsActive} Activo · {referralsPending} Pendiente de validación</small>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>

            {/* TARJETA PRINCIPAL: CÓDIGO QR Y ENLACE */}
            <CCard className="border border-secondary-subtle shadow-none rounded-3 mb-4 bg-body">
                <CCardHeader className="bg-body border-bottom border-secondary-subtle py-3">
                    <h6 className="mb-0 fw-bold text-body">Programa Referir Negocios Aliados</h6>
                </CCardHeader>
                <CCardBody className="p-4 text-body">
                    <CRow className="align-items-center g-4">
                        {/* Columna QR */}
                        <CCol md={3} className="text-center border-end-md border-secondary-subtle">
                            <div
                                className="p-2 bg-body-tertiary rounded-3 d-inline-block border border-secondary-subtle mb-2"
                                style={{ width: '140px', height: '140px' }}
                            >
                                <img
                                    src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(
                                        referralLink
                                    )}`}
                                    alt="Código QR de Referido"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="small text-body-secondary">Escanea para registrar tienda</div>
                        </CCol>

                        {/* Columna Información */}
                        <CCol md={9} className="ps-md-4">
                            <h5 className="fw-bold text-body mb-1">Gana $15.000 de saldo por cada tienda aliada</h5>
                            <p className="text-body-secondary small mb-3">
                                Invita a otros restaurantes o comercios a sumarse a la plataforma. Una vez procesen sus primeras órdenes, el saldo se acreditará directamente a tu billetera.
                            </p>

                            <div className="mb-3">
                                <label className="form-label small fw-semibold text-body-secondary">Enlace personal de referido</label>
                                <CInputGroup size="sm">
                                    <CFormInput value={referralLink} readOnly className="bg-body-tertiary text-body border-secondary-subtle" />
                                    <CButton
                                        color="dark"
                                        onClick={handleCopy}
                                        className="fw-medium text-white px-3"
                                    >
                                        {copied ? 'Copid' : 'Copiar Link'}
                                    </CButton>
                                </CInputGroup>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                <CButton
                                    color="secondary"
                                    // className="border border-secondary-subtle text-body fw-medium"
                                    className="text-body bg-body-tertiary border border-secondary-subtle px-3 py-1 fw-normal"
                                    size="sm"
                                    onClick={() =>
                                        window.open(
                                            `https://wa.me/?text=${encodeURIComponent(
                                                `¡Hola! Te invito a unirte a DomicilApp para gestionar tus domicilios y pedidos sin comisiones abusivas. Regístrate usando mi link: ${referralLink}`
                                            )}`,
                                            '_blank'
                                        )
                                    }
                                >
                                    Compartir por WhatsApp
                                </CButton>
                                <CBadge color="secondary" className="text-body bg-body-tertiary border border-secondary-subtle px-3 py-2 fw-normal">
                                    Código: <strong className="ms-1">{referralCode}</strong>
                                </CBadge>
                            </div>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>

            {/* TABLA DE TIENDAS REFERIDAS */}
            <CCard className="border border-secondary-subtle shadow-none bg-body rounded-3">
                <CCardHeader className="bg-body border-bottom border-secondary-subtle py-3 text-body">
                    <h6 className="mb-0 fw-bold">Historial de Comercios Referidos</h6>
                </CCardHeader>
                <CCardBody className="p-0">
                    <CTable align="middle" responsive hover className="mb-0 text-body">
                        <CTableHead className="bg-body-tertiary border-bottom border-secondary-subtle">
                            <CTableRow>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Comercio</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Propietario</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Fecha</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Bono</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Estado</CTableHeaderCell>
                            </CTableRow>
                        </CTableHead>
                        <CTableBody>
                            {referrals.map((item) => (
                                <CTableRow key={item.id} className="border-bottom border-secondary-subtle">
                                    <CTableDataCell className="fw-semibold text-body">{item.referral_store_name}</CTableDataCell>
                                    <CTableDataCell className="text-body">{item.user_own_fullname}</CTableDataCell>
                                    <CTableDataCell className="text-body-secondary small">{item.created_at}</CTableDataCell>
                                    <CTableDataCell className="fw-semibold text-body">{currencyFormat.format(item.reward_amount)}</CTableDataCell>
                                    <CTableDataCell>
                                        {item.status === 'paid' ? (
                                            // <span className="badge bg-success-subtle text-success-emphasis border border-success-subtle rounded-pill px-2 py-1 font-normal">
                                                <CBadge color="success-subtle" className="text-success border border-success-subtle px-2 py-1">
                                                Acreditado
                                            </CBadge>
                                        ) : (
                                            // <span className="badge bg-body-tertiary text-body-secondary border border-secondary-subtle rounded-pill px-2 py-1 font-normal">
                                                <CBadge color="secondary-subtle" className="text-secondary border px-2 py-1">
                                                Pendiente
                                                </CBadge>
                                        )}
                                    </CTableDataCell>
                                </CTableRow>
                            ))}
                        </CTableBody>
                    </CTable>
                </CCardBody>
            </CCard>
        </>
    );
};

export default MarketingReferrals;